import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AuthManager from '../../../shared/services/AuthManager';
import { sendVerificationLink } from '../../../shared/actions/auth';
import config from '../../../shared/services/config';

class EmailVerificationLink extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.shape({
      state: PropTypes.object,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
      replace: PropTypes.func,
    }).isRequired,
  };

  state = {
    isLoading : true
  }

  createParams() {
    const { state: historyState } = this.props.location;
    let { userEmail, user } = historyState;
    userEmail = userEmail || user.email;
    this.fullToken = AuthManager.getFullToken();
    if (!historyState) {
      this.props.history.replace('/account');
    }
    const params = {
      token: this.fullToken,
      type: 'EmailVerification',
      identity: userEmail,
    }
    this.params = params;
  }


  componentWillMount() {
    this.createParams();
  }

  onProceed = async () => {
    sendVerificationLink(this.props.dispatch, {
      ...this.params,
    }).then(() => {
      const { state: historyState } = this.props.location;
      this.props.history.replace({
        pathname: historyState.redirectTo.shift(),
        state: {
          ...this.props.location.state,
        }
      });
    });
  }

  render() {
    const AccountCreated = config.get('accountCreatedComponent');
    return (
      <div className="container">
        <div className="text-center mt-2">
          <AccountCreated/>
          <h2>We will send an email verification link to your registered email ID.</h2>
          <h4>Please click on that link to verify your email and secure your account.</h4>
          <button
            id="emailVerificationLink"
            onClick={this.onProceed}
            className="dflt-btn mt-4"
          >
            PROCEED
          </button>
        </div>
      </div>
    );
  }
}

export default connect()(EmailVerificationLink);
